import { Component } from '@angular/core';
import {
  UntypedFormControl,
  UntypedFormGroup,
  Validators,
} from '@angular/forms';
import { FormLayout } from 'ng-devui';
import { catchError, throwError } from 'rxjs';
import { LoginForm } from 'src/app/modules/shared/models/login/login-form.model';
import { LoginInfo } from 'src/app/modules/shared/models/login/login-info.model';
import { LoginSource } from 'src/app/modules/shared/models/login/login-source.enum';
import { LoginType } from 'src/app/modules/shared/models/login/login-type.enum';
import { User } from 'src/app/modules/shared/models/staff/user.model';
import { GlobalService } from 'src/app/modules/shared/providers/global.service';
import { OmUserPersonService } from 'src/app/modules/shared/services/om-user-person.service';
import { StaffUserService } from 'src/app/modules/shared/services/staff-user.service';
import { environment } from 'src/environments/environment';
import { Md5 } from 'ts-md5';

// declare var VANTA: any;

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
})
export class LoginComponent {
  // @ViewChild('vanta') vanta!: ElementRef;
  form: UntypedFormGroup;
  phone: UntypedFormControl;
  password: UntypedFormControl;
  captchaCode!: UntypedFormControl;
  captchaId = '';
  captchaImage = '';
  readonly needCaptcha = environment.needCaptcha;
  rememberPassword: boolean;
  submitting: boolean = false;
  layoutDirection: FormLayout = FormLayout.Vertical;

  query = '';
  init = false;

  mit = '';
  constructor(
    private globalService: GlobalService,
    private omUserPersonService: OmUserPersonService,
    private staffUserService: StaffUserService,
  ) {
    const loginInfo = this.globalService.loginInfo;
    this.mit = this.globalService.mit;
    this.phone = new UntypedFormControl(
      '',
      Validators.compose([
        Validators.required,
        Validators.pattern('^1[0-9]{10}$'),
        // Validators.pattern("[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,3}$|^1[0-9]{10}$")
      ]),
    );
    this.password = new UntypedFormControl(
      '',
      Validators.compose([
        Validators.required,
        // Validators.pattern("^(?=.*?[A-Z]*)(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$%^&*-]*).{8,24}$")
      ]),
    );
    const controls: Record<string, UntypedFormControl> = {
      phone: this.phone,
      password: this.password,
    };
    if (this.needCaptcha) {
      this.captchaCode = new UntypedFormControl('', Validators.required);
      controls['captchaCode'] = this.captchaCode;
    }
    this.form = new UntypedFormGroup(controls);
    this.rememberPassword = true;
  }

  ngOnInit(): void {
    this.query = window.location.href.split('?')[1] ?? '';
    this.init = true;
    if (!!this.query && window.location.href.indexOf('login') > -1) {
      this.globalService.clearLoginInfo();
      this.globalService.passwordFree = true;
      this.loginWithoutPassword();
    } else {
      if (window.location.href.indexOf('signin') !== -1) {
        this.globalService.passwordFree = false;
        if (this.needCaptcha) {
          this.refreshCaptcha();
        }
      } else {
        location.href = '/#/signin';
        this.globalService.clearLoginInfo();
      }
    }
  }

  ngAfterViewInit(): void {
    //Called after ngAfterContentInit when the component's view has been initialized. Applies to components only.
    //Add 'implements AfterViewInit' to the class.
    // VANTA.NET({
    //   el: '.view-container',
    //   mouseControls: true,
    //   touchControls: true,
    //   gyroControls: false,
    //   minHeight: 200.0,
    //   minWidth: 200.0,
    //   scale: 1.0,
    //   scaleMobile: 1.0,
    //   color: 0x3fbbff,
    //   backgroundColor: 0x15253c,
    // });
  }

  loginWithoutPassword(): void {
    const params = new URLSearchParams(this.query);
    this.omUserPersonService
      .loginWithoutPwd(params.get('token') ?? '')
      .subscribe((loginOutInfo: LoginInfo) => {
        if (loginOutInfo) {
          this.globalService.token = loginOutInfo.token!;
          this.prepareUserInfo(loginOutInfo);
        } else {
          if (!!params.get('redirectFail')) {
            location.href = params.get('redirectFail')!;
          } else {
            this.query = '';
          }
        }
      });
  }

  login(loginInfo: any): void {
    this.submitting = true;
    const loginForm: LoginForm = {
      phone: loginInfo.phone,
      password: Md5.hashStr(loginInfo.password).toString(),
      loginType: LoginType.PASSWORD,
      loginSource: LoginSource.WEB,
      platform: 'web',
    };
    if (this.needCaptcha) {
      loginForm.captchaId = this.captchaId;
      loginForm.captchaCode = loginInfo.captchaCode;
    }
    this.omUserPersonService
      .login(loginForm)
      .pipe(
        catchError((err) => {
          this.submitting = false;
          if (this.needCaptcha) {
            this.captchaCode.reset();
            this.refreshCaptcha();
          }
          return throwError(err);
        }),
      )
      .subscribe((loginOutInfo: LoginInfo) => {
        this.submitting = false;
        if (loginOutInfo) {
          this.globalService.token = loginOutInfo.token!;

          this.prepareUserInfo(loginOutInfo);
        }
      });
  }

  refreshCaptcha(): void {
    this.omUserPersonService.captcha().subscribe((captcha) => {
      this.captchaId = captcha.captchaId;
      this.captchaImage = captcha.image.startsWith('data:')
        ? captcha.image
        : `data:image/png;base64,${captcha.image}`;
    });
  }

  private prepareUserInfo(info: LoginInfo) {
    this.staffUserService.findById(info.uid!).subscribe((user: User) => {
      this.globalService.userInfo = user;
      this.globalService.login(info);
    });
    //   zip(
    //     // this.omUserPersonService.getPlatUser(),
    //     this.staffUserService.findById(info.uid!),
    //     this.staffOrganizationService.findById(info.organizationId!)
    //     // this.staffOrganizationProjectService.findAll<OrganizationProjectListRequest>(
    //     //   {
    //     //     organizationId: info.organizationId,
    //     //     projectId: this.globalService.projectId,
    //     //   }
    //     // )
    //   ).subscribe((responses: [PlatUser, User, Organization]) => {
    //     this.globalService.userInfo = Object.assign(responses[0], responses[1]);
    //     const org = responses[2];
    //     this.globalService.orgInfo = org;
    //     // console.log(this.globalService.orgInfo);
    //     this.globalService.login(info);
    //   });
  }
}
